const RuleOnSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="26.665">
      <g data-name="グループ 61" fill="none" stroke-miterlimit="10">
        <path data-name="Icon awesome-stamp" d="M28 25.665H0" className="main-stroke" stroke-width="2" />
        <g data-name="グループ 60">
          <g data-name="パス 64">
            <path d="M17.5 13.892v-2.02a9.293 9.293 0 011.174-4.25 5.188 5.188 0 00.495-3.3 5.251 5.251 0 00-6.1-4.238 5.251 5.251 0 00-4.321 5.165 5.142 5.142 0 00.475 2.165 19.641 19.641 0 011.275 6.474 1.611 1.611 0 01-1.606 1.614h10.216a1.61 1.61 0 01-1.608-1.61z" />
            <path
              d="M15.5 13.502v-1.69c.055-1.792.542-3.565 1.409-5.131.31-.616.414-1.326.292-2.005a3.246 3.246 0 00-3.776-2.624 3.249 3.249 0 00-2.675 3.2c0 .444.096.892.279 1.298.998 2.008 1.371 5.435 1.455 6.952H15.5m3.61 2H8.894a1.61 1.61 0 001.606-1.614c-.059-1.73-.494-4.93-1.275-6.474a5.142 5.142 0 01-.475-2.165 5.251 5.251 0 0110.419-.927 5.188 5.188 0 01-.495 3.3 9.293 9.293 0 00-1.174 4.25v2.02c0 .889.721 1.61 1.61 1.61z"
              className="main-fill"
            />
          </g>
          <g data-name="パス 65">
            <path d="M22.75 13.999H5.25A5.249 5.249 0 000 19.249v1.75a1.75 1.75 0 001.75 1.75h24.5a1.751 1.751 0 001.75-1.75v-1.75a5.25 5.25 0 00-5.25-5.25z" />
            <path
              d="M5.25 15.999A3.254 3.254 0 002 19.249v1.5h24v-1.5a3.254 3.254 0 00-3.25-3.25H5.25m0-2h17.5a5.25 5.25 0 015.25 5.25v1.75a1.75 1.75 0 01-1.75 1.75H1.75A1.75 1.75 0 010 20.999v-1.75c0-2.9 2.35-5.25 5.25-5.25z"
              className="main-fill"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default RuleOnSvg
